export default {"src":"/_next/static/media/minus.58137e19.svg","height":2,"width":16};